import angular from 'angular';
import lmiPredominant from './lmiPredominant';
import lmiPredominantCtrl from './lmiPredominantCtrl';

export default angular
  .module('components.lmiPredominant', [])
  .controller('LmiPredominantCtrl', lmiPredominantCtrl)
  .component('lmiPredominant', lmiPredominant).name;
